import React, { useReducer } from "react";
import tableReducer from "./tableReducer";
import tableContext from "./tableContext";
import {
  SUCCESS_GET_DATA_TRANSACTIONS,
  SUCCESS_GET_DATA_SHIFTCLOSURES,
  SUCCESS_GET_DATA_RCOFHISTORY,
  CHANGE_PAGE,
  CHANGE_LOADING,
  SET_TRANSACTION_TABLE,
  SET_SHIFT_CLOSURES_TABLE,
  SET_RCOF_HISTORY_TABLE,
  ERROR_GET_DATA,
  SET_FILTER,
  REMOVE_FILTERS,
  SET_QUERY_FILE,
  CLOSE_SESION,
  SET_MAX_PER_PAGE
} from "../../types";

import tokenAuth from "../../config/token";
import axiosClient from "../../config/axios";

const TableState = (props) => {
  const initialState = {
    data: [],
    columns: [],
    maxPerPage: !localStorage.getItem("maxPerPage")
      ? 10
      : localStorage.getItem("maxPerPage"),
    currentPage: 1,
    totalRows: 0,
    totalPages: 0,
    loading: true,
    sessionExpired: false,
    transactionTable: !localStorage.getItem("transactionTable")
      ? true
      : localStorage.getItem("transactionTable"), //true,
    shiftClosuresTable: !localStorage.getItem("shiftClosuresTable")
      ? true
      : localStorage.getItem("shiftClosuresTable"), //false,
    rcofHistoryTable: !localStorage.getItem("rcofHistoryTable")
      ? true
      : localStorage.getItem("rcofHistoryTable"), //false,
    error: false,
    errorMessage: "",
    filters: !JSON.parse(localStorage.getItem("filters"))
      ? {
        applied: false,
        filter: "",
        terminal: "",
        visualizeBy: 1,
        dateTo: "",
        dateFrom: "",
        documentType: null,
      }
      : JSON.parse(localStorage.getItem("filters")),
    queryFile: !localStorage.getItem("queryFile")
      ? ""
      : localStorage.getItem("queryFile"),
    searchFilterTransaction: "",
  };

  const [state, dispatch] = useReducer(tableReducer, initialState);

  const getTransactionsData = async () => {
    const filtersApplied = `&${state.filters.filter ? `Filter=${state.filters.filter}` : ""
      }${state.filters.terminal ? `&Terminal=${state.filters.terminal}` : ""}${state.filters.dateFrom ? `&DateFrom=${state.filters.dateFrom}` : ""
      }${state.filters.dateTo ? `&DateTo=${state.filters.dateTo}` : ""}${state.filters.documentType
        ? `&DocumentType=${state.filters.documentType}`
        : ""
      }`;

    try {
      const response = await axiosClient.post(
        `/transactions/${state.maxPerPage}/${state.currentPage}/?&VisualizeBy=${state.filters.visualizeBy
        }${state.filters.applied ? filtersApplied : ""}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      dispatch({
        type: SUCCESS_GET_DATA_TRANSACTIONS,
        payload: response.data.data,
      });

      dispatch({
        type: SET_QUERY_FILE,
        payload: filtersApplied,
      });
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesiòn ha caducado, por favor haga login nuevamente", //error.message,
        });
      } else {
        dispatch({
          type: ERROR_GET_DATA,
          payload: "Ha ocurrido un error al cargar los datos.", //error.message,
        });
      }
    }
  };

  const getshiftsClosureData = async () => {
    const filtersApplied = `&${state.filters.filter ? `Filter=${state.filters.filter}` : ""
      }${state.filters.dateFrom ? `&DateFrom=${state.filters.dateFrom}` : ""}${state.filters.dateTo ? `&DateTo=${state.filters.dateTo}` : ""
      }${state.filters.terminal ? `&Terminal=${state.filters.terminal}` : ""}`;
    try {
      const response = await axiosClient.post(
        `/shiftsClosures/${state.maxPerPage}/${state.currentPage}${state.filters.applied ? filtersApplied : ""
        }`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      dispatch({
        type: SUCCESS_GET_DATA_SHIFTCLOSURES,
        payload: response.data.data,
      });
      dispatch({
        type: SET_QUERY_FILE,
        payload: filtersApplied,
      });
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesiòn ha caducado, por favor haga login nuevamente", //error.message,
        });
      } else {
        dispatch({
          type: ERROR_GET_DATA,
          payload: "Ha ocurrido un error al cargar los datos.", //error.message,
        });
      }
    }
  };

  const getRcofHistoryData = async () => {
    const filtersApplied = `&${state.filters.filter ? `Filter=${state.filters.filter}` : ""
      }${state.filters.dateFrom ? `&DateFrom=${state.filters.dateFrom}` : ""}${state.filters.dateTo ? `&DateTo=${state.filters.dateTo}` : ""
      }${state.filters.terminal ? `&Terminal=${state.filters.terminal}` : ""}`;
    try {
      const response = await axiosClient.post(
        `/rcofHistory/${state.maxPerPage}/${state.currentPage}${state.filters.applied ? filtersApplied : ""
        }`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      dispatch({
        type: SUCCESS_GET_DATA_RCOFHISTORY,
        payload: response.data.data,
      });
      dispatch({
        type: SET_QUERY_FILE,
        payload: filtersApplied,
      });
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesiòn ha caducado, por favor haga login nuevamente", //error.message,
        });
      } else {
        dispatch({
          type: ERROR_GET_DATA,
          payload: "Ha ocurrido un error al cargar los datos.", //error.message,
        });
      }
    }
  };

  const getExportFileTransactions = async () => {
    try {
      const response = await axiosClient.post(
        `/exporttransactionshistoryexcel/?${state.queryFile}`
      );

      const csvData = new Blob([response.data], {
        type: "text/csv;charset=utf-8;",
      });

      let dataResponse = {
        csvData,
        status: true,
      };
      return dataResponse;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesiòn ha caducado, por favor haga login nuevamente", //error.message,
        });
      } else {
        let dataResponse = {
          status: false,
        };
        return dataResponse;
      }
    }
  };

  const getDteStatus = async (number, documentType, dteStatusId) => {
    try {
      let filters = `?${documentType ? `&DocumentType=${documentType}` : ""}${number ? `&DocumentNumber=${number}` : ""}${dteStatusId ? `&DteStatusId=${dteStatusId}` : ""}`;

      const response = await axiosClient.post(
        `/getDteStatus/${filters}`
        ,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );



      let dataResponse = {
        response,
        status: true,
      };
      return dataResponse;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesiòn ha caducado, por favor haga login nuevamente", //error.message,
        });
      } else {
        let dataResponse = {
          status: false,
        };
        return dataResponse;
      }
    }
  }

  const voidTransaction = async (internalReference) => {
    try {
      const response = await axiosClient.post(
        "/voidTransaction",
        { internalReference }
      );
      return { response, status: true };
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({ type: CLOSE_SESION, payload: "La sesión ha caducado, por favor haga login nuevamente" });
      } else {
        return { status: false };
      }
    }
  };

  const getTransactionDetail = async (internalReference) => {
    try {
      const response = await axiosClient.post(
        `/transactionDetail?InternalReference=${internalReference}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      return { response, status: true };
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesión ha caducado, por favor haga login nuevamente",
        });
      } else {
        return { status: false };
      }
    }
  };

  const getExportFileXml = async (number, documentType) => {
    try {
      let filters = `?${documentType ? `&DocumentType=${documentType}` : ""}${number ? `&DocumentNumber=${number}` : ""
        }`;

      const response = await axiosClient.post(
        `/exportxmltransaction/${filters}`
      );

      const xmlData = new Blob([response.data], {
        type: "text/xml;charset=utf-8;",
      });

      let dataResponse = {
        xmlData,
        status: true,
      };
      return dataResponse;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesiòn ha caducado, por favor haga login nuevamente", //error.message,
        });
      } else {
        let dataResponse = {
          status: false,
        };
        return dataResponse;
      }
    }
  };


  const getExportFileShiftClosures = async () => {
    try {
      const response = await axiosClient.post(
        `/exportshiftclosurehistoryexcel/?${state.queryFile}`
      );

      const csvData = new Blob([response.data], {
        type: "text/csv;charset=utf-8;",
      });

      let dataResponse = {
        csvData,
        status: true,
      };
      return dataResponse;
      /* return FileSaver.saveAs(csvData, "Reporte.csv"); */
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesiòn ha caducado, por favor haga login nuevamente", //error.message,
        });
      } else {
        let dataResponse = {
          status: false,
        };
        return dataResponse;
      }
    }
  };


  const postRegenerateSingleRcof = async (trackingId) => {
    try {
      //console.log(`T: ${trackingId}`)
      const params = {
        trackingDetailId: trackingId
      }
      const response = await axiosClient.post(
        `/regenerateSingleRCOF`,
        params
      );


      if (response.data.data.responseCode === 0) {
        return {
          status: true

        }
      }
      else {
        return {
          status: false,
          msg: response.data.data.responseMessage
        }
      }
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesión ha caducado, por favor haga login nuevamente", //error.message,
        });
      } else {
        let dataResponse = {
          status: false,
        };
        return dataResponse;
      }
    }
  };

  const changePage = (page) => {
    dispatch({
      type: CHANGE_PAGE,
      payload: page,
    });
  };

  const changeLoading = (change) => {
    dispatch({
      type: CHANGE_LOADING,
      payload: change,
    });
  };

  const setTransactionTable = () => {
    dispatch({
      type: SET_TRANSACTION_TABLE,
    });
  };

  const setShiftClosuresTable = () => {
    dispatch({
      type: SET_SHIFT_CLOSURES_TABLE,
    });
  };

  const setRcofHistoryTable = () => {
    dispatch({
      type: SET_RCOF_HISTORY_TABLE,
    });
  };

  const removeFilters = () => {
    dispatch({
      type: REMOVE_FILTERS,
    });
  };

  const setFilter = (filter, value) => {
    const data = {
      filter,
      value,
    };

    dispatch({
      type: SET_FILTER,
      payload: data,
    });
  };

  const setMaxPerPage = (value) => {
    dispatch({
      type: SET_MAX_PER_PAGE,
      payload: value,
    });
  };

  return (
    <tableContext.Provider
      value={{
        data: state.data,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        loading: state.loading,
        sessionExpired: state.sessionExpired,
        transactionTable: state.transactionTable,
        shiftClosuresTable: state.shiftClosuresTable,
        rcofHistoryTable: state.rcofHistoryTable,
        error: state.error,
        errorMessage: state.errorMessage,
        searchFilterTransaction: state.searchFilterTransaction,
        filters: state.filters,
        queryFile: state.queryFile,
        maxPerPage: state.maxPerPage,
        getTransactionsData,
        getshiftsClosureData,
        getRcofHistoryData,
        changePage,
        changeLoading,
        setTransactionTable,
        setShiftClosuresTable,
        setRcofHistoryTable,
        setFilter,
        removeFilters,
        getExportFileTransactions,
        getExportFileXml,
        getDteStatus,
        getTransactionDetail,
        voidTransaction,
        getExportFileShiftClosures,
        postRegenerateSingleRcof,
        setMaxPerPage,
      }}
    >
      {props.children}
    </tableContext.Provider>
  );
};

export default TableState;
